import api from 'common/services/api';
import PropositionListing from 'common/modules/proposition/domain/propositionListing';
import type { FetchCampaignOptions } from 'common/modules/campaign/domain/Campaign';
import Proposition from 'common/modules/proposition/domain/proposition';
import AgeRangeReachesAPIHelper from 'common/helpers/AgeRangeReachesAPIHelper';

function createParams(options: FetchCampaignOptions) {
  return {
    searchText: options.searchText,
    sortBy: options.sortBy,
    page: options.currentPage,
    limit: options.limit,
    filterBy: options.filterBy,
  };
}

class PropositionAPI {
  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token })

  async listPropositions(advertiserReference: string, token: string, options: FetchCampaignOptions): Promise<PropositionListing[]> {
    const url = `/follo/${advertiserReference}/campaigns/proposed`;

    const { data } = await api.get(url, createParams(options), { headers: this.buildHeaders(token) });
    const { items } = data;

    return items.map(i => PropositionListing.parse(i));
  }

  async fetchProposedCampaign(advertiserReference: string, token: string, reference: string): Promise<Proposition> {
    const url = `/follo/${advertiserReference}/campaigns/proposed/${reference}`;

    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    const json = assembleFlattenedData(data);
    return Proposition.parse(json);
  }

  async acceptProposition(advertiserReference: string, token: string, reference: string): Promise<Proposition> {
    const url = `/follo/${advertiserReference}/campaigns/proposed/${reference}/accept`;

    const { data } = await api.put(url, {}, { headers: this.buildHeaders(token) });

    const json = assembleFlattenedData(data);
    return Proposition.parse(json);
  }

  async declineProposition(advertiserReference: string, token: string, reference: string): Promise<Proposition> {
    const url = `/follo/${advertiserReference}/campaigns/proposed/${reference}/cancel`;

    const { data } = await api.put(url, {}, { headers: this.buildHeaders(token) });

    const json = assembleFlattenedData(data);
    return Proposition.parse(json);
  }
}

function assembleFlattenedData(data: Object): Object {
  return {
    ...data,
    estimation: {
      ...data.estimation,
      ageGroup: AgeRangeReachesAPIHelper.flatToJson(data.estimation.ageGroup),
    },
  };
}

export default new PropositionAPI();



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/services/PropositionAPI.js